import {HttpRequest} from "../utils/httpRequest";

let InviteNet = {
    /**
     * 获取数据列表
     * @param params
     */
    getIvNetList(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/net/list',
            method: 'get',
            data: params
        });
    },
    /**
     * 获取所有数据
     * @returns {*}
     */
    getIvNets() {
        return HttpRequest.getRequest({
            url: '/edu/invite/net/all',
            method: 'get'
        });
    },
    /**
     * 获取数据记录
     * @returns {*}
     */
    getIvNetCount() {
        return HttpRequest.getRequest({
            url: '/edu/invite/net/count',
            method: 'get'
        });
    },
    /**
     * id 查询
     * @param id
     */
    getIvNetInfo(id) {
        return HttpRequest.getRequest({
            url: '/edu/invite/net/info/' + id,
            method: 'get'
        });
    },
    /**
     * 新增或编辑数据
     * @param datas
     */
    addOrUpdateIvNet(type, datas) {
        return HttpRequest.getRequest({
            url: '/edu/invite/net/' + type,
            method: 'post',
            data: datas
        });
    },
    /**
     * 删除数据
     * @param params
     * @returns {*}
     */
    deleteIvNet(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/net/delete',
            method: 'get',
            data: params
        });
    }
};
export {InviteNet}
